export function makeCenterTextPlugin(text: string, percent: string, color = "#222") {
    return {
        id: 'centerText',
        afterDraw(chart: { ctx: any; chartArea: { width: any; height: any } }) {
            const { ctx, chartArea: { width, height } } = chart;
            ctx.save();

            // Draw main text
            ctx.font = 'bold 1.1em sans-serif';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = color;
            ctx.fillText(text, width / 2, height / 2);

            // Draw percentage below the main text
            ctx.font = '0.9em sans-serif';
            ctx.fillStyle = 'grey';
            ctx.fillText(percent, width / 2, height / 2 + 20);

            ctx.restore();
        }
    };
}